import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  getAllPageSuccess,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error,
  getAllPage,
} from './actions';

import { ServiceLotacao } from '~/services/modulos/serviceLotacao';
import { createSagaReutils, createAllTakeLastDefault } from '~/utils/reutils';

import ACTION from '../actionTypes';

const ACOES_DEFULT = createSagaReutils(
  `/lotacao`,
  ServiceLotacao,
  getAllPage,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error
);

function* listPageableSaga({ params }) {
  try {
    const list = yield call(ServiceLotacao.getAllPageable, params);
    yield put(getAllPageSuccess(list));
  } catch (e) {
    yield put(error(e));
  }
}

export default all([
  ...createAllTakeLastDefault({ modulo: 'LOTACAO', ACOES: ACOES_DEFULT }),
  takeLatest(ACTION.LOTACAO_GET_SEARCH_PAGE, listPageableSaga),
]);
